import FileGalleryModalContainer from './FileGalleryModalContainer'
export { FileGalleryModalContainer }
export default FileGalleryModalContainer



// WEBPACK FOOTER //
// ./src/components/FileGalleryModal/index.js